import React from 'react';

export function useCurrencyFormat() {
  const formatCurrency = React.useCallback((price: number | null | undefined) => {
    let number = new Intl.NumberFormat('jp-JA', {
      // style: 'currency',
      // currency: 'JPY',
    }).format(price || 0);

    return `JPY ${number}`;
  }, []);
  return { formatCurrency };
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  price: number | null | undefined;
}
export const NTACurrencyFormat = ({ price, ...props }: Props) => {
  const { formatCurrency } = useCurrencyFormat();
  return <span {...props}>{formatCurrency(price)}</span>;
};

export const formatPriceWithCurrency = (price: any, currency: string | null | undefined) => {
  let number = new Intl.NumberFormat('jp-JA', {
    // style: 'currency',
    // currency: 'JPY',
  }).format(price || 0);
  return `${currency} ${number}`;
};
